import { renderSlot as _renderSlot, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "reports-menu-root bc-2 earthquake-menu" }
const _hoisted_2 = {
  key: 0,
  class: "actions"
}
const _hoisted_3 = /*#__PURE__*/_createTextVNode("戻る")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_time_seeker = _resolveComponent("time-seeker")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _renderSlot(_ctx.$slots, "left"),
    (_ctx.showAdminBack)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_router_link, {
            to: "/admin/menu",
            class: "actions-item"
          }, {
            default: _withCtx(() => [
              _hoisted_3
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: _normalizeClass([_ctx.isShowSummary ? 'show-summary' : '', "calendar-controller"])
    }, [
      _createVNode(_component_time_seeker, {
        onPrev: _ctx.movePrev,
        onToday: _ctx.moveNow,
        onNext: _ctx.moveNext
      }, null, 8, ["onPrev", "onToday", "onNext"]),
      _createElementVNode("div", {
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.hideSummary && _ctx.hideSummary(...args))),
        class: "btn-change-summary back hide-pc"
      }, "戻る"),
      _createElementVNode("button", {
        id: "info",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.openInfo()))
      }, "発生情報")
    ], 2),
    _renderSlot(_ctx.$slots, "default")
  ]))
}